import React, { Component } from "react";
import {
  Checkbox,
  Table,
  Icon,
  Container,
  Header,
  Input,
  Dropdown,
  Grid,
  Form,
  Popup,
  Modal,
  Accordion,
  List,
  TextArea,
  Button,
  Label
} from "semantic-ui-react";
import "./WO.css";
import WodRemaining from "../../services/wodremaining";
import moment from "moment";
import { hashHistory } from "react-router";
import Roundy from "../../services/roundy";
class WodForm extends Component {
  constructor() {
    super();
    this.state = {
      editing: false,
      additional_supplement: 0,
      closeModal: false,
      filemodal: false
    };
  }
  // componentDidMount() {
  //   console.log(this.props.wod.locationCode);
  // }

  setwod(newwod) {
    this.setState({ wod: newwod });
  }

  handlechange(param, value) {
    let currentwod = this.props.wod;
    currentwod[param] = value;
    //    console.log(currentwod[param]);
    if (this.state.editing === false) {
      this.setState({ wod: currentwod, editing: true });
    }
    this.setState({ wod: currentwod });
  }
  // componentDidUpdate(prevProps, prevState) {
  //   console.log("new wo", this.props.wod.workordernumber);
  // }
  genchargetable() {
    if (
      this.props.wod.workOrderNbr.length === 7 &&
      this.props.deriv_charges &&
      this.props.deriv_charges.length
    ) {
      return (
        <Accordion id="charge_array" styled>
          {this.props.deriv_charges.map((wo, i) => {
            var ctotal = wo.charge_report.find(cr => cr.name === "Total");
            if (ctotal) {
              console.log("Charge report", wo);
              return (
                <div>
                  <Accordion.Title
                    active={this.state.activeWoCharge === wo.workOrderNbr}
                    index={i}
                    onClick={() =>
                      this.setState({
                        activeWoCharge:
                          this.state.activeWoCharge !== wo.workOrderNbr
                            ? wo.workOrderNbr
                            : null
                      })
                    }
                  >
                    <div>
                      <h3 id="charge_table_title">
                        <span id="charge_table_wonum">
                          <Icon name="dropdown" />
                          {wo.workOrderNbr}
                        </span>

                        <span id="charge_table_desc"> {wo.description}</span>
                        <span id="charge_table_total">${ctotal.charged}</span>
                      </h3>
                    </div>
                  </Accordion.Title>
                  <Accordion.Content
                    active={this.state.activeWoCharge === wo.workOrderNbr}
                  >
                    <Table fluid>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell>Employee/Material</Table.HeaderCell>
                          <Table.HeaderCell>Discipline</Table.HeaderCell>
                          <Table.HeaderCell>Rate</Table.HeaderCell>
                          <Table.HeaderCell>Total Hours</Table.HeaderCell>
                          <Table.HeaderCell>Charged</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {this.genfancyrowleft(wo.charge_report)}
                      </Table.Body>
                    </Table>
                  </Accordion.Content>
                </div>
              );
            }
          })}
        </Accordion>
      );
    }
  }
  genwodtable() {
    let wod = this.props.wod;
    const workorderFundingOptions = [
      { key: 1, text: "CAPITAL", value: "C" },
      { key: 2, text: "DIRECT", value: "D" },
      { key: 3, text: "EXPENSE", value: "E" },
      { key: 4, text: "OTHER", value: "O" }
    ];
    var rootwod = wod.workOrderNbr.slice(0, 7)
    var budget_status = wod.root_wonumber === rootwod ? true : false
    // budget status is true if wod is being budgeted with main wod
    var asslist = [];

    if (wod.assigned && wod.assigned.length) {
      wod.assigned.map(a => {
        if (!asslist.find(ass => ass.empnumber === a.empnumber)) {
          asslist = asslist.concat(a);
        }
      });
    }

    let closedfield = (
      <div>
        <Input
          type="date"
          name="workOrderDateClosed"
          value={this.props.wod.dateClosed ? wod.dateClosed : ""}
          error={
            moment(this.props.wod.dateClosed).isBefore(moment()) &&
            wod.assigned &&
            wod.assigned.length
          }
          onChange={e => {
            this.handlechange(
              "dateClosed",
              moment(e.target.value).format("YYYY-MM-DD")
            );
            if (!e.target.value) {
              this.props.handlepatch("dateClosed", null);
            }
          }}
          onBlur={e => {
            var newdate = e.target.value
              ? moment(e.target.value).format("YYYY-MM-DD")
              : null;
            this.props.handlepatch("dateClosed", newdate);
          }}
          fluid
        />
      </div>
    );
    var assignedlist = <div />;

    assignedlist = asslist.map(ass => (
      <List.Item>
        {ass.employee.firstname + " " + ass.employee.lastname}
      </List.Item>
    ));
    let new_supplement = (
      parseFloat(wod.supplements) + parseFloat(this.state.additional_supplement)
    ).toFixed(2);
    let remaining = WodRemaining(wod);
    return (
      <Table structured compact>
        <Table.Body>
          <Table.Row>
            <Table.Cell>
              <Label>Work Order:</Label>
              <Dropdown
                options={this.props.wodoptions}
                search
                name="workOrderNumber"
                selection
                onChange={(e, { value }) => {
                  hashHistory.push("/work-orders/" + value);
                }}
                value={wod.workOrderNbr}
                fluid
              />
            </Table.Cell>
            <Table.Cell>
              <Label>Description:</Label>
              <Input
                type="text"
                name="workOrderDescription"
                value={wod.description}
                onChange={e => this.handlechange("description", e.target.value)}
                onBlur={e => {
                  this.props.handlepatch("description", e.target.value);
                }}
                fluid
              />
            </Table.Cell>
            <Table.Cell rowSpan="2">
              <Form>
                <Label attached="top">Standard Work:</Label>
                <TextArea
                  name="WodFormtandardWork"
                  fluid
                  value={wod.standardWork}
                  onBlur={e => {
                    this.props.handlepatch("standardWork", e.target.value);
                  }}
                  onChange={e =>
                    this.handlechange("standardWork", e.target.value)
                  }
                />
              </Form>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Label>Create Date:</Label>
              <Input
                type="date"
                name="workOrderCreateDate"
                value={wod.createDate}
                fluid
              />
            </Table.Cell>
            <Table.Cell>
              <Label>Comp/Dept:</Label>
              <Input name="workorderCompDept" fluid value={wod.custnumber} />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Label>Est End Date:</Label>
              <Input
                header="Employees Assigned"
                type="date"
                name="workOrderEstEndDate"
                value={wod.endJobDate}
                onChange={e => {
                  this.handlechange(
                    "endJobDate",
                    moment(e.target.value).format("YYYY-MM-DD")
                  );
                }}
                onBlur={e =>
                  this.props.handlepatch(
                    "endJobDate",
                    moment(e.target.value).format("YYYY-MM-DD")
                  )
                }
                fluid
              />
            </Table.Cell>
            <Table.Cell>
              <Label>Customer/PM:</Label>
              <Dropdown
                name="workorderCustPM"
                fluid
                selection
                onChange={(e, { value }) => {
                  this.handlechange("contactName", value);
                  this.props.handlepatch("contactName", value);
                }}
                value={wod.contactName}
                options={this.props.pms}
              />
            </Table.Cell>
            <Table.Cell>
              <Label>TJA#:</Label>
              <Input
                type="text"
                name="workOrderTJA"
                value={wod.tjaNbr}
                onChange={e => {
                  this.handlechange("tjaNbr", e.target.value);
                }}
                onBlur={e => this.props.handlepatch("tjaNbr", e.target.value)}
                fluid
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Label>Date Closed:</Label>
              <Popup
                divided
                hoverable
                on={wod.assigned && wod.assigned.length ? "hover" : "none"}
                trigger={closedfield}
              >
                <Popup.Header>Assigned Employees:</Popup.Header>
                <Popup.Content>
                  {assignedlist}
                  <Button
                    size="mini"
                    compact
                    color="orange"
                    onClick={() => this.props.removeAssigned()}
                  >
                    Remove All
                  </Button>
                </Popup.Content>
              </Popup>
            </Table.Cell>
            <Table.Cell>
              <Label>Billing:</Label>
              <Dropdown
                name="workorderBilling"
                fluid
                selection
                onChange={(e, { value }) =>
                  this.handlechange("billingNbr", value)
                }
                options={this.props.billing}
                value={wod.billingNbr}
              />
            </Table.Cell>
            <Table.Cell>
              <Label>Sent to Legal:</Label>
              <Input
                type="date"
                name="WodFormSentLegal"
                value={wod.dateLegal}
                onChange={e =>
                  this.handlechange(
                    "dateLegal",
                    moment(e.target.value).format("YYYY-MM-DD")
                  )
                }
                onBlur={e => {
                  this.props.handlepatch(
                    "dateLegal",
                    moment(e.target.value).format("YYYY-MM-DD")
                  );
                }}
                fluid
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Label>SOW#:</Label>
              <Input
                type="text"
                name="WodFormOW"
                fluid
                value={wod.acctNbr}
                onChange={e => this.handlechange("acctNbr", e.target.value)}
              />
            </Table.Cell>
            <Table.Cell>
              <Label>Program:</Label>
              <Dropdown
                name="workorderProgram"
                fluid
                selection
                value={wod.program}
                onChange={(e, { value }) => this.handlechange("program", value)}
                options={this.props.program}
              />
            </Table.Cell>
            <Table.Cell>
              <Label>Funding Type:</Label>
              <Dropdown
                name="workorderFunding"
                defaultValue={3}
                fluid
                selection
                options={workorderFundingOptions}
                value={wod.fundingType}
                onChange={(e, { value }) =>
                  this.handlechange("fundingType", value)
                }
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Label>PO#:</Label>
              <Input
                type="text"
                name="workOrderPO"
                value={wod.poNbr}
                onChange={e => {
                  this.handlechange("poNbr", e.target.value);
                }}
                onBlur={e => {
                  this.props.handlepatch("poNbr", e.target.value);
                }}
                fluid
              />
            </Table.Cell>
            <Table.Cell>
              <Label>Location:</Label>
              <Dropdown
                name="workorderLocation"
                fluid
                value={wod.locationCode}
                onChange={(e, { value }) => {
                  this.handlechange("locationCode", value);
                  console.log(wod.locationCode);
                }}
                selection
                options={this.props.location}
              />
            </Table.Cell>
            <Table.Cell>
              <Label>Appropriation</Label>
              <Input
                type="text"
                name="workOrderAppropriation"
                value={wod.appropriation}
                onChange={e => {
                  this.handlechange("appropriation", e.target.value);
                }}
                onBlur={e =>
                  this.props.handlepatch("appropriation", e.target.value)
                }
                fluid
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Label>PO Item#:</Label>
              <Input
                type="text"
                name="workOrderPOItem"
                value={wod.poItemNbr}
                onChange={e => this.handlechange("poItemNbr", e.target.value)}
                onBlur={e => {
                  this.props.handlepatch("poItemNbr", e.target.value);
                }}
                fluid
              />
            </Table.Cell>
            <Table.Cell rowSpan={3}>
              <Form>
                <Label attached="top">Comments:</Label>
                <TextArea
                  name="workOrderComments"
                  fluid
                  value={wod.comments}
                  onChange={e => this.handlechange("comments", e.target.value)}
                  onBlur={e => {
                    this.props.handlepatch("comments", e.target.value);
                  }}
                />
              </Form>
            </Table.Cell>
            <Table.Cell>
              <Label>Prev. Year Adj:</Label>
              <Input
                label="$"
                type="text"
                name="workOrderPYA"
                value={wod.prevYearAdj}
                onChange={e => this.handlechange("prevYearAdj", e.target.value)}
                onBlur={e => {
                  this.props.handlepatch("prevYearAdj", e.target.value);
                }}
                fluid
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell />
            <Table.Cell>
              <Label>Budget:</Label>
              <Input
                label="$"
                type="text"
                value={wod.budget}
                onChange={e => {
                  if (this.state.editing === false) {
                    this.setState({ editing: true });
                  }
                  this.handlechange("budget", e.target.value);
                }}
                onBlur={e => {
                  this.props.handlepatch("budget", e.target.value);
                }}
                name="workOrderBudget"
                fluid
              />
              {wod.workOrderNbr.length <= 7 ? (
                <div>
                  <Label>Derivative Budget:</Label>
                  <Input
                    label="$"
                    type="text"
                    value={wod.derivBudget}
                    name="workOrderDerivBudget"
                    fluid
                  />
                </div>
              ) : (
                <div />
              )}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Label>PO Start Date:</Label>
              <Input
                type="date"
                name="workOrderPOStart"
                value={wod.poStart}
                onChange={e =>
                  this.handlechange(
                    "poStart",
                    moment(e.target.value).format("YYYY-MM-DD")
                  )
                }
                onBlur={e => {
                  this.props.handlepatch(
                    "poStart",
                    moment(e.target.value).format("YYYY-MM-DD")
                  );
                }}
                fluid
              />
            </Table.Cell>
            <Table.Cell>
              <Label>Supplements:</Label>
              <Input
                label="$"
                type="text"
                value={wod.supplements}
                onChange={e => this.handlechange("supplements", e.target.value)}
                onBlur={e => {
                  this.props.handlepatch("supplements", e.target.value);
                }}
                name="WodFormupplements"
                fluid
              >
                <Label>$</Label>
                <input />
                <Button
                  primary
                  icon="plus"
                  onClick={() => this.setState({ addSupplements: true })}
                />
              </Input>
              <Modal
                open={this.state.addSupplements}
                onClose={() => this.setState({ addSupplements: false })}
                closeOnEscape
                size="fullscreen"
                basic
                closeOnRootNodeClick
              >
                <Header textAlign="center">Add Supplement</Header>
                <Modal.Content id="supp_modal">
                  <Input
                    label="$"
                    type="number"
                    placeholder="Supplement Addition"
                    value={this.state.additional_supplement || null}
                    onChange={e =>
                      this.setState({
                        additional_supplement: e.target.value
                      })
                    }
                  />
                  <div id="supp_btns">
                    {this.state.additional_supplement ? (
                      <h3>
                        ${wod.supplements} + ${this.state.additional_supplement}{" "}
                        = ${new_supplement}
                      </h3>
                    ) : (
                      <h3>${wod.supplements}</h3>
                    )}
                  </div>
                  <div id="supp_btns">
                    <Button
                      basic
                      color="red"
                      inverted
                      onClick={() =>
                        this.setState({
                          addSupplements: false,
                          additional_supplement: 0
                        })
                      }
                    >
                      <Icon name="remove" /> Cancel
                    </Button>
                    <Button
                      color="green"
                      inverted
                      disabled={!this.state.additional_supplement}
                      onClick={() => {
                        this.handlechange("supplements", new_supplement);
                        this.props.handlepatch(
                          "supplements",
                          new_supplement.toString()
                        );
                        this.setState({
                          addSupplements: false,
                          additional_supplement: 0
                        });
                      }}
                    >
                      <Icon name="checkmark" /> Confirm
                    </Button>
                  </div>
                </Modal.Content>
              </Modal>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Label>PO End Date:</Label>
              <Input
                type="date"
                name="workOrderPOEnd"
                value={wod.po_End}
                onChange={e =>
                  this.handlechange(
                    "po_End",
                    moment(e.target.value).format("YYYY-MM-DD")
                  )
                }
                onBlur={e => {
                  this.props.handlepatch(
                    "po_End",
                    moment(e.target.value).format("YYYY-MM-DD")
                  );
                }}
                fluid
              />
            </Table.Cell>
            <Table.Cell>
              <Checkbox
                label="Invoice as Main"
                name="workorderContractLabor"
                value
                checked={wod.invWorkOrderMain}
                onChange={(e, { value }) => {
                  let newvalue = 1 - value;
                  console.log(newvalue);
                  this.props.handlepatch("invWorkOrderMain", newvalue);
                  this.handlechange("invWorkOrderMain", newvalue);
                }}
              />
                  
                    <Checkbox
                label="Budget as Derivative"
                name="workorderContractLabor"
                checked={budget_status}
                onChange={(e, { value }) => {
                  let newvalue = budget_status? wod.workOrderNbr: wod.workOrderNbr.slice(0, 7);
                  console.log(newvalue);

                  this.props.handlepatch("root_wonumber", newvalue);
                  this.handlechange("root_wonumber", newvalue);
                }}
              />
              <Checkbox
                label="Contract Labor"
                name="workorderContractLabor"
                value={wod.contractLabor}
                checked={!!wod.contractLabor}
                onChange={(e, { value }) => {
                  let newvalue = 1 - value;
                  this.props.handlepatch("contractLabor", newvalue);
                  this.handlechange("contractLabor", newvalue);
                }}
              />
              <Checkbox
                label="Fixed Price"
                value={wod.fixedPrice}
                checked={!!wod.fixedPrice}
                onChange={(e, { value }) => {
                  console.log(value);
                  let newvalue = 1 - value;
                  console.log(newvalue);
                  this.props.handlepatch("fixedPrice", newvalue);
                  this.handlechange("fixedPrice", newvalue);
                }}
                name="workorderFixedPrice"
              />
            </Table.Cell>
            <Table.Cell>
              <Label>Negotiated:</Label>
              <Input
                label="$"
                type="text"
                value={wod.negotiated}
                onChange={e => this.handlechange("negotiated", e.target.value)}
                onBlur={e => {
                  this.props.handlepatch("negotiated", e.target.value);
                }}
                name="workOrderNegotiated"
                fluid
              />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell />
            <Table.Cell />
            <Table.Cell>
              <Label>Remaining:</Label>
              <Input
                label="$"
                type="text"
                error={remaining && remaining < 0}
                value={remaining}
                name="workOrderTotal"
                fluid
              />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  genwodseccondtable() {
    if (this.props.wod && this.props.customer) {
      return (
        <Table structured compact>
          <Table.Body>
            <Table.Row colSpan={2}>
              <Table.Cell>
                Total charges for ({this.props.wod.workOrderNbr}) to date{" "}
                {/* work order number in () */}
              </Table.Cell>
              <Table.Cell />
            </Table.Row>
            <br />
            <Table.Row>
              <Table.Cell>Created on: {this.props.wod.createDate}</Table.Cell>
              <Table.Cell>For: {this.props.customer.custname}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                Job Description: {this.props.wod.description}
              </Table.Cell>
              <Table.Cell>PO#: {this.props.wod.poNbr}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }
  }

  genfancyrowleft(report = this.props.chargereport) {
    if (report.length) {
      return report.map(entry => {
        return (
          <Table.Row>
            <Table.Cell>{entry.name}</Table.Cell>
            <Table.Cell>{entry.discipline}</Table.Cell>
            <Table.Cell>
              {entry.empnumber ? "$" + parseInt(entry.rate) : "-"}
            </Table.Cell>
            <Table.Cell>
              {typeof entry.hours === "number"
                ? entry.hours.toFixed(2)
                : entry.hours}
            </Table.Cell>
            <Table.Cell>${Roundy(entry.charged)}</Table.Cell>
          </Table.Row>
        );
      });
    }
  }
  genfancytableright() {
    var totalabor = 0;
    if (this.props.wod && this.props.labor.length) {
      console.log("my Labor", this.props.labor);

      this.props.labor.map(entry => {
        totalabor = totalabor + entry.charged;
      });
      return (
        <Table>
          <Table.Body>
            <Table.Row>
              <Table.Cell>Amount Charged:</Table.Cell>
              <Table.Cell>{this.props.wod.charged}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Labor Charges:</Table.Cell>
              <Table.Cell>{totalabor}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Material Charges::</Table.Cell>
              <Table.Cell>{"this.state.materialcharge"}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Total Budget:</Table.Cell>
              <Table.Cell>{this.props.wod.budget}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Previous Year Spent:</Table.Cell>
              <Table.Cell>{this.props.wod.prevYearAdj}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Remaining:</Table.Cell>
              <Table.Cell>{parseInt(this.props.wod.remaining)}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }
  }
  render() {
    let workorder = this.props.wod;
    const searchOptions = [
      { key: 1, text: "Search All", value: "ALL" },
      { key: 2, text: "Engineer", value: "Customers.Contact_Name" },
      { key: 3, text: "Customer", value: "Customers.Customer_Name" },
      { key: 4, text: "Funding Type", value: "Funding_Types.Funding_Type" },
      { key: 5, text: "SOW #", value: "Work_Orders.Acct_Nbr" },
      { key: 6, text: "Billing #", value: "Work_Orders.Billing#" },
      { key: 7, text: "INDIRECT", value: "Work_Orders.CCN_Nbr" },
      { key: 8, text: "Description", value: "Work Order Description" },
      { key: 9, text: "Location Code", value: "Work_Orders.Location_Code" },
      { key: 10, text: "ZPM #", value: "Work_Orders.MDA_Nbr" },
      { key: 11, text: "PO Item #", value: "Work_Orders.PO_Item_Nbr" },
      { key: 12, text: "PO #", value: "Work_Orders.PO_Nbr" },
      { key: 13, text: "Program", value: "Work_Orders.Program" },
      { key: 14, text: "SAP #", value: "Work_Orders.SAP_Nbr" },
      { key: 15, text: "TJA #", value: "Work_Orders.TJA_Nbr" },
      { key: 16, text: "Work Order #", value: "Work_Orders.Work_Order_Nbr" }
    ];

    const jumpWodFormOptions = [
      {
        key: 1,
        text: "06-0220 - 1701 (9905) AEP Dual Fuel Conversion and Woodward EOL",
        value: "06-0220"
      },
      { key: 2, text: "09-0246 - RAIDER HUNG LANDING GEAR", value: "09-0246" },
      {
        key: 3,
        text: "45-0020 - ENGINEERING SUPPORT FOR TEST AREA",
        value: "45-0020"
      }
    ];
    if (this.props.wod) {
      var mat_entry_disabled = this.props.wod.dateClosed ? true : false;

      return (
        <div className="WodForm" id="wodgrid">
          <Container fluid>
            <Grid>
              <Grid.Column floated="left" width={12}>
                <Grid.Row centered>
                  <Grid.Column>
                    <Header as="h3" block id="Title">
                      Work Order Data Entry - WO #{this.props.wod.workOrderNbr}
                      <Button id="btn_open_close" as="div" labelPosition="left">
                        <Label as="a" basic color="black" pointing="right">
                          Status
                        </Label>
                        <Button
                          size="tiny"
                          color={mat_entry_disabled ? "red" : "green"}
                          inverted
                          onClick={() =>
                            this.setState({
                              closeModal: true
                            })
                          }
                        >
                          {mat_entry_disabled ? "Closed" : "Open"}
                        </Button>
                      </Button>
                    </Header>
                  </Grid.Column>
                </Grid.Row>
                <Grid>
                  <Grid.Row centered>
                    <Button size="tiny">
                      <Icon name="print" /> Print
                    </Button>
                    <Button
                      size="tiny"
                      onClick={() => {
                        this.props.handlemodal("matentry");
                      }}
                      disabled={mat_entry_disabled}
                    >
                      <Icon name="shopping cart" /> Material Entry
                    </Button>
                    <Button
                      size="tiny"
                      onClick={() => {
                        hashHistory.push(
                          "/jobtracker/" + this.props.wod.workOrderNbr
                        );
                      }}
                    >
                      <Icon name="wrench" /> Job Tracker Admin
                    </Button>
                    <Button
                      size="tiny"
                      onClick={() => {
                        this.props.handlemodal("filemodal")
                      }}
                    >
                      <Icon name="file" /> Job Files
                    </Button>
                    <Button size="tiny">
                      <Icon name="money" /> Invoice Details
                    </Button>

                    <Button size="tiny">
                      <Icon name="dollar" /> Enter Job Fees
                    </Button>

                    <Button
                      size="tiny"
                      onClick={() => this.props.relatedwods(true)}
                    >
                      <Icon name="list" /> Derivative List
                    </Button>
                    <Button size="tiny">Request PO Number</Button>
                    <Button
                      size="tiny"
                      onClick={() => {
                        this.props.handlemodal("assigned");
                      }}
                    >
                      Assignments
                    </Button>
                    <Button
                      size="tiny"
                      onClick={() => this.props.createderivative()}
                    >
                      Create Derivative
                    </Button>
                  </Grid.Row>
                </Grid>
                <Grid.Row centered>
                  <Grid.Column>{this.genwodtable()}</Grid.Column>
                </Grid.Row>

                <Grid>
                  <Grid.Row centered>
                    <Button
                      size="tiny"
                      disabled={this.props.undeletable}
                      onClick={() => {
                        this.props.deletewod();
                      }}
                    >
                      <Icon name="remove" /> Delete
                    </Button>
                    <Button
                      size="tiny"
                      onClick={() => {
                        this.props.handlesave(this.props.wod);
                      }}
                    >
                      <Icon name="save" /> Save
                    </Button>

                    <Button
                      size="tiny"
                      onClick={() => {
                        this.props.handlereset();
                      }}
                    >
                      Reset
                    </Button>

                    <Button
                      size="tiny"
                      disabled={!this.props.tmstatus}
                      onClick={() => {
                        this.props.handlemodal("tmlist");
                      }}
                    >
                      <Icon name="newspaper" /> View T/M Report
                    </Button>

                    <Button
                      size="tiny"
                      disabled={!this.props.invenabled}
                      onClick={() => {
                        this.props.handlemodal("invlist");
                      }}
                    >
                      <Icon name="newspaper" /> Invoices
                    </Button>

                    <Button
                      size="tiny"
                      disabled={this.props.wod && !this.props.wod.estimate}
                      onClick={() => {
                        hashHistory.push(
                          "/estimatereview/" + this.props.wod.estimate.id
                        );
                      }}
                    >
                      <Icon name="newspaper" /> View Estimate
                    </Button>
                  </Grid.Row>
                </Grid>
                <Grid>
                  <Grid.Row centered>
                    <Button size="tiny">
                      <Icon name="fast forward" /> SEND CUSTOMER LOGIN
                      INFORMATION () {/*TODO: Customer name in () */}
                    </Button>
                    <Button size="tiny">
                      <Icon name="fast forward" /> VIEW STATUS REPORT
                    </Button>
                    <Button size="tiny">
                      <Icon name="fast forward" /> VIEW MATERIAL CHARGES REPORT
                    </Button>
                  </Grid.Row>
                  <Grid.Row centered>
                    <Grid.Column width={12}>
                      {this.genwodseccondtable()}
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row centered>
                    <Grid.Column width={10}>
                      <Table fluid>
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell>
                              Employee/Material
                            </Table.HeaderCell>
                            <Table.HeaderCell>Discipline</Table.HeaderCell>
                            <Table.HeaderCell>Rate</Table.HeaderCell>
                            <Table.HeaderCell>Total Hours</Table.HeaderCell>
                            <Table.HeaderCell>Charged</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>{this.genfancyrowleft()}</Table.Body>
                      </Table>
                      {this.genchargetable()}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid>
          </Container>
          <Modal
            open={this.state.closeModal}
            basic
            size="small"
            onClose={() => this.setState({ closeModal: false })}
          >
            <Header
              icon="archive"
              content={
                this.props.wod.dateClosed
                  ? "Open this workorder?"
                  : "Close this workorder?"
              }
            />
            <Modal.Content>
              {this.props.wod.dateClosed
                ? "Are you sure you would like to open this workorder"
                : "Are you sure you would like to close this workorder"}
            </Modal.Content>
           
            <Modal.Actions>
              <Button
                color={this.props.wod.dateClosed ? "green" : "red"}
                inverted
                onClick={() => {
                  var status = this.props.wod.dateClosed
                    ? null
                    : moment().format("YYYY-MM-DD");
                  this.props.handlepatch("dateClosed", status);
                  this.setState({ closeModal: false });
                }}
              >
                <Icon name="checkmark" />
                {this.props.wod.dateClosed ? "Open" : "Close"} Work Order
              </Button>
            </Modal.Actions>
          </Modal>
        </div>
      );
    } else {
      return <div />;
    }
  }
}

export default WodForm;



// WEBPACK FOOTER //
// ./src/components/wod/WorkOrders.js